import { render, staticRenderFns } from "./WhitelabelIntermediary.vue?vue&type=template&id=1e4630cb&"
import script from "./WhitelabelIntermediary.vue?vue&type=script&lang=js&"
export * from "./WhitelabelIntermediary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports